export enum EditorMode {
    DEFAULT,
    ADD,
    MOVE,
}
